import { loadCurrentUser } from '../../../Services/userAuth';

export default async (result, dispatch, props) => {
  const { config } = props;
  
  // Load user data and permissions after successful login
  try {
    await dispatch(loadCurrentUser());
  } catch (error) {
    console.error('Failed to load user data after login:', error);
  }
  
  // Call the original success handler if it exists
  if (config.login && config.login.onSuccess) {
    dispatch(config.login.onSuccess());
  }
}
